import type { RouteId } from "@base/site/routes";
import HubPage from "@/pages/hub/HubPage";
import NotFound from "@/pages/NotFound";

import {
  eager,
  lazyWithPreload,
  type PreloadableComponent,
} from "./lazyWithPreload";

/** One component per registry route; adding a route without one fails to compile. */
export const ROUTE_COMPONENTS = {
  home: eager(HubPage),
  developers: lazyWithPreload(
    () => import("@/pages/developers/DevelopersLanding")
  ),
  business: lazyWithPreload(() => import("@/pages/business/BusinessLanding")),
  apps: lazyWithPreload(() => import("@/pages/apps/AppsLanding")),
  nutrinima: lazyWithPreload(() => import("@/pages/apps/Nutrinima")),
  jobxtech: lazyWithPreload(() => import("@/pages/apps/Jobxtech")),
  privacyPolicy: lazyWithPreload(() => import("@/pages/PrivacyPolicy")),
  termsOfUse: lazyWithPreload(() => import("@/pages/TermsOfUse")),
  cookiePolicy: lazyWithPreload(() => import("@/pages/CookiePolicy")),
  gymteroPrivacy: lazyWithPreload(() => import("@/pages/apps/GymteroPrivacy")),
  gymteroDeleteAccount: lazyWithPreload(
    () => import("@/pages/apps/GymteroDeleteAccount")
  ),
  gymteroDownload: lazyWithPreload(
    () => import("@/pages/apps/GymteroDownload")
  ),
  blogList: lazyWithPreload(() => import("@/pages/blog/BlogList")),
  blogPost: lazyWithPreload(() => import("@/pages/blog/BlogPost")),
  notFound: eager(NotFound),
} satisfies Record<RouteId, PreloadableComponent>;
